import { render, staticRenderFns } from "./Printable.Appointment.vue?vue&type=template&id=5bb5777a"
import script from "./Printable.Appointment.vue?vue&type=script&lang=js"
export * from "./Printable.Appointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports